import React from "react";

const PillSkeleton = ({ length = 1, ...props }) => {
  const { height, width, flexWrap } = props;
  return (
    <div className={`flex ${flexWrap ?? "flex-wrap"} gap-2`}>
      {Array.from({ length }).map((_, index) => (
        <div
          key={index}
          className={`inline-block h-9 ${width ?? "w-24"} rounded-full bg-gray-300`}
        ></div>
      ))}
    </div>
  );
};

export default PillSkeleton;
